var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.activeNotifications.length,
          expression: "activeNotifications.length"
        }
      ],
      staticClass: "notifications"
    },
    [
      _c(
        "transition-group",
        { attrs: { name: "notifications" } },
        _vm._l(_vm.activeNotifications, function(n) {
          return _c(
            "div",
            { key: n.id, staticClass: "notifications-item" },
            [
              _c(
                "ui-notification",
                {
                  attrs: { closable: "", title: n.title, color: n.color },
                  on: {
                    remove: function($event) {
                      return _vm.REMOVE_NOTIFICATION(n.id)
                    }
                  }
                },
                [_vm._v("\n        " + _vm._s(n.message) + "\n      ")]
              )
            ],
            1
          )
        }),
        0
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }